import { getTimeDelay } from '@nsftx/games-visualization-sdk/src/utility';
import { eventBus } from '../utility';
import * as mocks from '@/mocks';
import types from './mutationTypes';

let countdownInterval = null;

export default {
  socket_handleEvent({ commit, dispatch, state }, message) {
    const event = message.type;
    const socketMock = mocks;
    const { dataMock } = state;
    let eventData = message.data;
    let raceId;
    let { sentTime } = message;
    if (dataMock) {
      if (event === 'state') {
        eventData = socketMock[message.data.type].state;
      } else {
        eventData = socketMock[event].message;
      }
      ({ sentTime } = eventData);
      raceId = eventData.raceId || eventData.data.raceId;
    } else {
      raceId = eventData.raceId || '-';
    }
    const eventType = eventData.type || event;
    let countdownTime;

    if (raceId) commit(types.SET_RACE_ID, raceId);
    if (eventType) dispatch('setStage', eventType);
    commit(types.SET_INFO_MESSAGE, '');

    switch (event) {
      case 'state':
        dispatch('setGameStateMode');
        // set offer/odds
        if (eventData.offer) {
          commit(types.SET_GAME_ODDS, eventData.offer);
        }
        // set tournament id
        if (eventData.tournamentIdToday) {
          commit(types.SET_TOURNAMENT_ID, eventData.tournamentIdToday);
        }

        if (eventType === 'countdown') {
          const delay = eventData.delay || eventData.data.delay || 0;
          countdownTime = getTimeDelay(eventData.time, sentTime, delay);
          commit(types.SET_COUNTDOWN_TIME, countdownTime);
          dispatch('setCountdownInterval');
        } else if (eventType === 'results') {
          if (eventData.winner) {
            commit(types.SET_WINNER_RESULTS, eventData.winner);
          }
          if (eventData.knockout) {
            commit(types.SET_KNOCKOUT_RESULTS, eventData.knockout);
          }
          commit(types.SET_GAME_RESULTS, eventData);
        } else if (eventType === 'race') {
          const delay = eventData.delay || eventData.data.delay || 0;
          const startTime = delay - getTimeDelay(eventData.time, sentTime, delay);
          if (eventData.videoId) {
            commit(types.SET_VIDEO_ID, eventData.videoId);
          }
          commit(types.SET_RACE_START_TIME, startTime);
        }
        break;

      case 'countdown':
        // set offer/odds
        commit(types.SET_GAME_ODDS, eventData.offer);
        // set tournament id
        if (eventData.tournamentIdToday) {
          commit(types.SET_TOURNAMENT_ID, eventData.tournamentIdToday);
        }
        countdownTime = eventData.delay;
        commit(types.SET_COUNTDOWN_TIME, countdownTime);
        commit(types.SET_EVENT_TIME, {
          type: 'countdown',
          time: countdownTime,
        });
        dispatch('setCountdownInterval');
        break;

      case 'race':
        // set race video
        if (eventData.videoId) {
          commit(types.SET_VIDEO_ID, eventData.videoId);
        }
        commit(types.SET_INFO_MESSAGE, 'waitingForTheRace');
        // set video start to beginning
        commit(types.SET_RACE_START_TIME, 0);
        break;
      case 'results':
        if (eventData.winner) {
          commit(types.SET_WINNER_RESULTS, eventData.winner);
        }
        if (eventData.knockout) {
          commit(types.SET_KNOCKOUT_RESULTS, eventData.knockout);
        }
        commit(types.SET_GAME_RESULTS, eventData);
        break;

      default:
        break;
    }

    eventBus.$emit('event', eventType);
  },
  socket_connect({ commit }) {
    commit(types.SOCKET_CONNECTED);
  },
  socket_disconnect({ commit }) {
    commit(types.SOCKET_DISCONNECTED);
  },
  setStage({ commit }, value) {
    commit(types.SET_STAGE, value);
  },
  activateLoader({ commit }) {
    commit(types.SET_LOADER_STATE, true);
  },
  deactivateLoader({ commit }) {
    commit(types.SET_LOADER_STATE, false);
  },
  setCountdownInterval({
    commit, dispatch, getters, state,
  }) {
    if (countdownInterval) clearInterval(countdownInterval);
    countdownInterval = setInterval(() => {
      let time = state.game.countdownTime - 1;

      if (countdownInterval && state.game.countdownTime <= 0) {
        clearInterval(countdownInterval);
        time = 0;
      }
      commit(types.SET_COUNTDOWN_TIME, time);
      if (getters.isLastCountdown && !getters.isLoaderActive) {
        dispatch('activateLoader');
      }
    }, 1000);
  },
  setGameStateMode({ commit }) {
    commit(types.SET_GAME_STATE_MODE, true);
    setTimeout(() => {
      commit(types.SET_GAME_STATE_MODE, false);
    }, 1000);
  },
  updateTranslations({ commit }, translations) {
    commit(types.UPDATE_TRANSLATIONS, translations);
  },
};
